import { useState, useEffect, useRef } from "react";
import Slider from "react-slick";
import { useGetApiQuery } from "../redux/services/apiHome";
import Loader from "./Loader";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";
import { useLanguageTranslation } from "../hooks/useLanguageTranslation";
import { initWOW } from "../Utils/wow";

function Banner() {
  const { languageType } = useSelector((state) => state.homeSlice);
  const { getText } = useLanguageTranslation();
  const { data: banners = [], isLoading: bannersIsLoading } = useGetApiQuery({
    url: "home_banner",
    lang: languageType,
  });

  const slider = useRef();

  const [showLoader, setShowLoader] = useState(false);
  const [isMuted, setIsMuted] = useState(true);

  const handleMuteUnmute = () => {
    const newMuted = !isMuted;
    setIsMuted(newMuted);

    const videos = document.querySelectorAll(".banner_section video");
    videos.forEach((video) => {
      video.muted = newMuted;
      video.volume = newMuted ? 0 : 1;
    });
  };

  useEffect(() => {
    const timer = setTimeout(() => {
      setShowLoader(bannersIsLoading);
    }, 5000);
    if (!bannersIsLoading) {
      setShowLoader(false);
    }
    return () => clearTimeout(timer);
  }, [bannersIsLoading]);

  useEffect(() => {
    if (!bannersIsLoading) {
      initWOW();
    }
  }, [bannersIsLoading]);

  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 12000,
    pauseOnHover: false,
    customPaging: function (i) {
      return <button aria-label={`Slide ${i + 1}`} tabIndex={0}></button>;
    },
    dotsClass: "slick-dots custom-dots",
    fade: true,
  };

  const [isPlaying, setIsPlaying] = useState(true);

  const next = () => {
    slider.current.slickNext();
  };
  const prev = () => {
    slider.current.slickPrev();
  };
  const play = () => {
    slider.current.slickPlay();
  };
  const pause = () => {
    slider.current.slickPause();
  };

  const handlePlayPause = () => {
    setIsPlaying((prev) => {
      if (prev) {
        pause();
      } else {
        play();
      }
      return !prev;
    });
  };

  if (showLoader) {
    return <Loader />;
  }

  return (
    <>
      <div className="banner_section">
        <div id="demo" className="carousel slide" data-ride="carousel">
          <div
            className="carousel-inner banner-sec"
            style={{ maxHeight: "758px" }}
          >
            <Slider {...settings} ref={slider}>
              {banners.map((banner, index) => {
                const videoUrl = banner.field_media_video_file
                  ? `${process.env.REACT_APP_IMAGE_URL}${banner.field_media_video_file}`
                  : "";

                const imageUrl = banner.field_banner_image
                  ? `${process.env.REACT_APP_IMAGE_URL}${banner.field_banner_image}`
                  : "";

                if (!videoUrl && !imageUrl) return null;

                return (
                  <div className="carousel-item" key={index}>
                    {videoUrl && (
                      <video
                        width="100%"
                        height="auto"
                        autoPlay
                        loop
                        muted
                        playsInline
                        className="banner-video"
                      >
                        <source src={videoUrl} type="video/mp4" />
                      </video>
                    )}

                    {!videoUrl && imageUrl && (
                      <img
                        src={imageUrl}
                        className="img-fluid w-100"
                        alt={banner.title}
                        style={{ maxHeight: "530px", objectFit: "cover" }}
                      />
                    )}

                    <div className="carousel-caption wow zoomIn">
                      <div className="container">
                        <div className="row">
                          <div className="col-12 col-sm-12 col-md-12 col-lg-6">
                            {banner.title && (
                              <>
                                <div className="bann-txt">{banner.title}</div>
                                <div className="underline"></div>
                              </>
                            )}
                            {banner.field_read_more_enable_disable === "On" && (
                              <Link
                                to={`/${banner.field_designation}`}
                                className="quick-btn"
                                aria-label={`Read more about ${banner.title}`}
                              >
                                {getText("Read More", "और पढ़ें")}
                              </Link>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                );
              })}
            </Slider>
            <div className="owl-nav mt-2">
              <div className="arrow">
                <button
                  className="left"
                  onClick={prev}
                  aria-label={`Previous banner item`}
                >
                  <i className="fa fa-angle-left"></i>
                </button>

                <button
                  className="play-pause"
                  onClick={handlePlayPause}
                  aria-label={
                    isPlaying ? `Pause banner item` : `Play banner item`
                  }
                >
                  <i
                    className={`fa ${!isPlaying ? "fa-play" : "fa-pause"}`}
                  ></i>
                </button>

                <button
                  className="right"
                  onClick={next}
                  aria-label={`Next banner item`}
                >
                  <i className="fa fa-angle-right"></i>
                </button>
              </div>
            </div>
            <div className="owl-nav mute-unmute mt-2">
              <div className="arrow">
                <button
                  className="mute-btn"
                  onClick={handleMuteUnmute}
                  aria-label={isMuted ? "Unmute video" : "Mute video"}
                >
                  <i
                    className={`fa ${
                      isMuted ? "fa-volume-mute" : "fa-volume-up"
                    }`}
                  ></i>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Banner;
